import { Application, Controller } from '@hotwired/stimulus';

const SESSION_STORAGE_KEY = 'browserSupportAlertDismissed';

/**
 * Shows a warning when user is using an unsupported browser
 * @example
 * <div data-controller="browser-support-alert">This browser is not supported</div>
 */
export class BrowserSupportAlertController extends Controller {
    static register(application: Application) {
        application.register('browser-support-alert', this);
    }

    static values = {
        force: {
            type: Boolean,
            default: false,
        },
    };

    declare readonly closeActionTarget: HTMLButtonElement;
    declare readonly forceValue: boolean;

    get alertDismissed(): boolean {
        const sessionValue = sessionStorage?.getItem(SESSION_STORAGE_KEY);
        return sessionValue && parseInt(sessionValue) === 1;
    }

    set alertDismissed(dismissed: boolean) {
        if (dismissed) {
            sessionStorage.setItem(SESSION_STORAGE_KEY, '1');
        } else {
            sessionStorage.removeItem(SESSION_STORAGE_KEY);
        }
    }

    connect(): void {
        // Browser Check happens inline in the alerts.macro
        if (this.forceValue) {
            this.element.removeAttribute('hidden');
        }
    }
}
